module.exports = __webpack_public_path__ + "static/media/LBN.639610f6.png";